import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosPagossuaArchivoComponent {
  editar
  accept
  titulo
  error
  onChange
  archivo = null

  constructor ($fileSystem, $q) {
    this.$fileSystem = $fileSystem
    this.$q = $q
  }

  leerArchivo (file) {
    const lector = new FileReader()

    let deferido = this.$q.defer()
    let promise = deferido.promise

    lector.onload = () => (deferido.resolve(lector.result))
    lector.onerror = () => {
      lector.abort()
      deferido.reject(new DOMException('Hubo un problema al leer el archivo'))
    }
    lector.readAsText(file)

    return promise
  }

  seleccionar () {
    if (!this.editar) return
    this.$fileSystem.select(false, this.accept)
      .then(file => {
        this.archivo = file[0].name
        this.leerArchivo(file[0])
          .then(text => (this.onChange({$event: {detail: text}})))
          .catch(error => (this.error = error))
      })
  }
}

module.component('recursoshumanosPagossuaArchivo', {
  controller: RecursoshumanosPagossuaArchivoComponent,
  template,
  bindings: {
    editar: '<',
    accept: '<',
    total: '<',
    titulo: '<',
    error: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/pagossua/archivo/component.js